import { Pipe, PipeTransform } from "@angular/core";
import { getSplitItem } from "../utils/formmater";

@Pipe({
  name: "fileSplit",
  standalone: true,
})
export class FileSplitPipe implements PipeTransform {
  transform(value: string | null, splitNumber: number = 0): string {
    return getSplitItem(value, splitNumber, "*");
  }
}
